import { Button } from '@chakra-ui/react';
import { links } from '@shared/utils';
import { Home } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import * as style from './styles';

export function NotFoundComponent() {
  const { t } = useTranslation('common');

  return (
    <div className={style.container()}>
      <div className={style.content()}>
        <main className={style.main()}>
          <span className={style.status()}>
            {t('defaultErrorTitle')}
            <br />
            {t('defaultErrorName')} 404
          </span>

          <div className={style.textWrapper()}>
            <p className={style.textError()}>{`${t('anErrorOccurred')}.`}</p>
          </div>
          <div className={style.buttons()}>
            <Link to={links.checkout.main} className={style.wrapperButton()}>
              <Button leftIcon={<Home className={style.homeIcon()} />}>
                {t('backToHome')}
              </Button>
            </Link>
          </div>
        </main>
      </div>
    </div>
  );
}
